import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {BsModalRef} from 'ngx-bootstrap/modal';
import{FrtBookShipmentAccessorialMsgs} from './frt-shipment-accessorial-additional'
@Component({
    selector: 'app-frt-shipment-accessorial-additionalinfo',
    templateUrl: './frt-shipment-accessorial-additionalinfo.component.html',
    styleUrls: ['./frt-shipment-accessorial-additionalinfo.component.css'],
    standalone: false
})

export class FrtShipmentAccessorialAdditionalInfoComponent implements OnInit {
	shipmentsId: any;
	bookAccessorialId: any;
	frtMessageForm: UntypedFormGroup;
	frtBookShipmentAccessorialMsgs: FrtBookShipmentAccessorialMsgs;
	additionalMessageResponse:any;
	redirectedFromBol: any;

	@Input() 
	public accId;

	@Input() 
	public title;

	@Input() 
	public shipmentId;

	@Input() 
	public messageHistoryArray;

	@Output() action = new EventEmitter();

	currentMessage: any;
	messageArray = [];
	constructor(private formBuilder: UntypedFormBuilder,
		private bsModalRef: BsModalRef
		) {
		this.frtMessageForm = this.formBuilder.group({
			newMessage: new UntypedFormControl('')
		});
	}

	ngOnInit() {
		window.scrollTo(0, 0);
		if (this.redirectedFromBol === true) {
			this.frtMessageForm.get('newMessage').disable();
		}
	}

	/**
	 * @description save message entered
	 */
	saveMessage() {
		this.currentMessage = new FrtBookShipmentAccessorialMsgs();
		this.currentMessage.shipmentAccrlsId = this.accId;
		this.currentMessage.message = this.frtMessageForm.get('newMessage').value;
		this.action.emit(this.currentMessage); 
		this.bsModalRef.hide();
	}

	/**
	 * @description Retrieve message history for the accessorial code from back-end
	 */
	loadMessageHistory(existingMessages) {
		for(let i = 0; i<existingMessages.length(); i++) {
			this.messageHistoryArray[i] = existingMessages[i].message;
		}
	}

	/**
	 * @description cancel message entered
	 */
	cancelMessage() {
		this.bsModalRef.hide();
	}
	

}
